<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="recyclingBinLogTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="weight" slot-scope="data">
          <span v-if="data.row.weight !== 0">{{ data.row.weight  }}</span>
        </template>
        <template slot="alarmStatus" slot-scope="data">
          <el-tag type="success" v-if="data.row.alarmStatus === '00000000'">正常</el-tag>
          <el-tag v-else-if="data.row.alarmStatus === '00000001'">满溢</el-tag>
          <el-tag v-else-if="data.row.alarmStatus === '00000016'">异常</el-tag>
          <el-tag v-else>已处理</el-tag>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>

</template>

<script>

export default {
  name: 'RecyclingBinLog',
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_RECYCLINGBINLOG_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/ablHardwareReports/dataList' }
        },
        formInputsData: [
          { name: 'SN', key: 'sn', value: '', type: 'text' },
          { name: '日期范围', key: 'createTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/ablHardwareReports/exportExcel',
          fileName: '箱体日志',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '公司名称', key: 'companyName' },
          { name: 'SN', key: 'sn', type: 'text' },
          { name: '箱体名称', key: 'boxName', type: 'text' },
          { name: '当前重量(Kg)', key: 'weight', type: 'custom' },
          { name: '总重量', key: 'totalWeight', type: 'text' },
          { name: '状态', key: 'alarmStatus', type: 'custom' },
          { name: '创建日期', key: 'createdAt', type: 'text', sortable: 'custom' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: true, index: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        // if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
        // this.$store.dispatch('setLopperDetailData', data.row)
        // }
      }
    }
  }
}
</script>
